export default {"src":"/_next/static/media/apartment.288017ba.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};